module.exports = __webpack_public_path__ + "static/media/tabs-icon-intreractive-objects.f18f34ba.svg";